import React, { useState } from "react";
import styles from "./potential-row.module.css";
import { getPotentialTypeLabel } from "../../functions/getPotentialFunctions";
import { getPotentialFactorTag, replaceColorTag } from "../../functions/stringFunctions";
import getImageFileName from "../../functions/getImageFileName";
import { LOCALES } from "../../constants";

export default function PotentialRow({ lang, potential }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const isGeneral = potential.type === "일반 잠재력";
    const activeLevel = isGeneral ? potential.levels?.at(-1) : potential.levels?.[0];
    const factorTag = getPotentialFactorTag(lang, activeLevel);
    const typeLabel = getPotentialTypeLabel(lang, potential);

    return (
        <div
            className={`${styles["row"]} ${isGeneral ? styles["clickable"] : ""}`}
            onClick={() => isGeneral && setIsExpanded((prev) => !prev)}
        >
            <div className={styles["main"]}>
                <div className={styles["icon-wrapper"]}>
                    <img className={styles["icon-bg"]} src={`${process.env.PUBLIC_URL}/images/icon/potential/bg_${potential.bgKey}.webp`} />
                    <img
                        className={styles["icon"]}
                        src={`${process.env.PUBLIC_URL}/images/icon/potential/${getImageFileName(potential.name[LOCALES.KO])}.webp`}
                    />
                </div>
                <div className={styles["info"]}>
                    <div className={styles["header-row"]}>
                        <span className={styles["name"]}>{potential.name[lang]}</span>
                        <span className={`${styles["badge"]} ${styles[potential.bgKey]}`}>{typeLabel}</span>
                    </div>
                    <div
                        className={styles["desc"]}
                        dangerouslySetInnerHTML={{ __html: activeLevel ? replaceColorTag(activeLevel.desc[lang]) : "" }}
                    ></div>
                    {factorTag && <div className={styles["factor"]} dangerouslySetInnerHTML={{ __html: factorTag }}></div>}
                </div>
                {isGeneral && <i className={`fi fi-rr-angle-small-down ${styles["chevron"]} ${isExpanded ? styles["expanded"] : ""}`} />}
            </div>

            {isGeneral && (
                <div className={`${styles["levels"]} ${isExpanded ? styles["expanded"] : ""}`}>
                    {(potential.levels ?? []).map((level) => (
                        <div className={styles["level-row"]} key={level.level}>
                            <span className={styles["level-num"]}>Lv.{level.level}</span>
                            <span className={styles["level-desc"]} dangerouslySetInnerHTML={{ __html: replaceColorTag(level.desc[lang]) }}></span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
